export default {"src":"/_next/static/media/favicon.597dfd60.ico","height":16,"width":16,"blurWidth":0,"blurHeight":0};